<template>
    <div class="siteEmbed" :class="{ 'siteEmbed--fullscreen': fullscreen }" @click.stop v-if="ready">
        <article>
            <div class="bg"></div>
            <iframe ref="iframe" :src="properties.siteUrl" :style="invertedScaleStyles"
                sandbox="allow-scripts allow-same-origin" @load="handleIframeLoad" @click.stop></iframe>
            <button class="button__close btnfx btnfx__clickflash btnfx__hoverscale" @click="closeComponent">
                <img src="@/assets/img/ui/close.svg" />
            </button>
            <a @click="closeComponent()" class="siteEmbed__close top" ref="btnclose"><img
                    src="@/assets/img/ui/close.svg" /></a>

        </article>
    </div>
</template>


<script>

import Logo from "../../ui/Logo.vue";
export default {
    components: {
        Logo,
    },
    props: [
        "properties",
        "pageData",
        "slug"
    ],
    data() {
        return {
            ready: false,
            fullscreen: true,
        }
    },
    mounted() {
        this.ready = true;
    },
    methods: {
        closeComponent() {
            console.log("close");
            this.$emit("closeComponent", this.slug)
        },
        getBackgroundImage() {
            return {
                'background-image': `url(${this.getCDNpath('assets/img/ui/slideshow-bg.png')})`
            }
        },
        getCDNpath(asset) {
            return app.api.Utils.getCDNpath(asset)
        },
        handleIframeLoad() {

        }
    },
    computed: {

        invertedScaleStyles() {
            // lets iframe content scale to always be 1! - despite any TK scale
            var currentScale = this.$store.getters.getScaleValue;
            var invertedScale = 1 / currentScale;
            var initScale = 95;
            return {
                'transform': `scale(${invertedScale})`,
                'height': `${currentScale * initScale}%`,
                'width': `${currentScale * initScale}%`
            }

        },
    }
};
</script>


<style lang="scss">
.siteEmbed {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    background-repeat: repeat;
    width: 100%;
    height: 100%;

    article {
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 1280px;
        height: 720px;


        &>.bg {
            position: absolute;
            height: 1420px;
            width: 1000px;
            background: linear-gradient(180deg, rgb(22, 77, 113, 1) 0%, rgba(10, 34, 58, 1) 100%);
            border-radius: 20px;
            // left:-20px;
             top:-40px;
            z-index: -2;
        }

        &>iframe {
            position: absolute;
            background-color: #fff;
            pointer-events: all;
            border: none;
            // border: 1px solid #fff;
        }

        &>.button__close {
            top: -70px;
            right: 0px;
            border: 3px solid var(--main-color-transparent);
            background-color: #fff;
        }

        &>.button__fs {
            right: 60px;
        }

        &>#logo {
            position: fixed;
            top: 24px;
            right: 43%;
            scale: 0.75;
            display: none;
        }
    }

    &--fullscreen {

        background: #000000bb;

        &>article {
            width: calc(100% - 80px);
            height: auto;
            top: 300px;
            bottom: 230px;
            margin-right: 0px;

            &>.button__close {
                top: -85px;
                right: 40px;

            }

            &>.button__fs {
                right: 100px;
            }

            &>#logo {
                display: flex;
            }
        }

    }


    &__close {
        pointer-events: all;
        position: absolute;

        width: 40px;
        height: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
         border: 2px solid #fff;
        // background-color: rgb(227, 98, 35);
        // background: linear-gradient(90deg, rgba(227, 98, 35, 1) 0%, rgba(227, 98, 35, 0) 100%);
        cursor: pointer;
        transition: background-color 0.3 ease-out;
        transform: translateX(100%);

        img {
            width:80%;
        }




        &.top {
            top: -22px;
            right: 64px;
            border-radius: 8px;
            // border-bottom: none;
        }

        &:active {
            transition: none;
            background-color: rgba(255, 255, 255, 0.5);
        }

    }

}
</style>
